export default function TopBanner() {
  return (
    <div className="bg-orange-600 text-white py-2 sm:py-3 px-3 sm:px-4 text-center relative z-50">
      <div className="container mx-auto">
        <p className="text-xs sm:text-sm md:text-base font-semibold tracking-wide uppercase leading-tight">
          EXCLUSIVO PARA EMPRESAS QUE FATURAM ACIMA DE 50 MIL AO MÊS
        </p>
      </div>
    </div>
  );
}
